import React from "react";

const Cloud = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_120_235)">
        <path
          d="M7.49999 18C6.25226 18 5.05564 17.5258 4.17337 16.6819C3.2911 15.838 2.79544 14.6934 2.79544 13.5C2.79544 12.3065 3.2911 11.1619 4.17337 10.318C5.05564 9.47406 6.25226 8.99995 7.49999 8.99995C7.79467 7.68713 8.65675 6.53343 9.89657 5.79267C10.5105 5.42587 11.1986 5.1715 11.9218 5.04406C12.6449 4.91663 13.3888 4.91863 14.1111 5.04995C14.8334 5.18127 15.5198 5.43934 16.1313 5.80943C16.7427 6.17952 17.2672 6.65437 17.6747 7.20688C18.0823 7.75939 18.3649 8.37873 18.5065 9.02955C18.6481 9.68036 18.6459 10.3499 18.5 11H19.5C20.4282 11 21.3185 11.3687 21.9749 12.0251C22.6312 12.6815 23 13.5717 23 14.5C23 15.4282 22.6312 16.3184 21.9749 16.9748C21.3185 17.6312 20.4282 18 19.5 18H18.5"
          stroke="#484848"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.5 15L12.5 12L15.5 15"
          stroke="#484848"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 12V21"
          stroke="#484848"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_120_235">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Cloud;
